import type { TechniqueDefinition } from "./TechniqueDefinition.js";

export const campoDeRelampagos: TechniqueDefinition = {
  id: "campo_de_relampagos",
  name: "Campo de Relâmpagos",
  description:
    "Electrifies an area, dealing periodic technique damage and reducing movement speed.",
  family: "elemental_ninjutsu",
  proficiency: "ninjutsu",
  targeting: "point_area",
  behavior: { kind: "field" },
  field: {
    kind: "persistent_field",
    durationMs: 6_000,
    pulseIntervalMs: 2_000,
    pulseCount: 3,
    activeLimitPerCaster: 1,
    recast: "replace",
    placement: "target_position",
  },
  levels: {
    1: {
      chakraCost: 28,
      cooldownMs: 10_000,
      range: 210,
      maxTargets: 5,
      power: 4,
      attackCoefficient: 0.28,
      radius: 64,
      fieldSlow: 0.1,
    },
    2: {
      chakraCost: 29,
      cooldownMs: 10_000,
      range: 210,
      maxTargets: 5,
      power: 4,
      attackCoefficient: 0.29,
      radius: 66,
      fieldSlow: 0.11,
    },
    3: {
      chakraCost: 30,
      cooldownMs: 10_000,
      range: 210,
      maxTargets: 5,
      power: 5,
      attackCoefficient: 0.31,
      radius: 68,
      fieldSlow: 0.12,
    },
    4: {
      chakraCost: 31,
      cooldownMs: 10_000,
      range: 210,
      maxTargets: 5,
      power: 5,
      attackCoefficient: 0.32,
      radius: 70,
      fieldSlow: 0.13,
    },
    5: {
      chakraCost: 32,
      cooldownMs: 10_000,
      range: 210,
      maxTargets: 5,
      power: 6,
      attackCoefficient: 0.34,
      radius: 72,
      fieldSlow: 0.14,
    },
    6: {
      chakraCost: 32,
      cooldownMs: 10_000,
      range: 210,
      maxTargets: 5,
      power: 6,
      attackCoefficient: 0.35,
      radius: 73,
      fieldSlow: 0.15,
    },
    7: {
      chakraCost: 33,
      cooldownMs: 10_000,
      range: 210,
      maxTargets: 5,
      power: 7,
      attackCoefficient: 0.36,
      radius: 74,
      fieldSlow: 0.16,
    },
    8: {
      chakraCost: 34,
      cooldownMs: 10_000,
      range: 210,
      maxTargets: 5,
      power: 7,
      attackCoefficient: 0.38,
      radius: 76,
      fieldSlow: 0.17,
    },
    9: {
      chakraCost: 35,
      cooldownMs: 10_000,
      range: 210,
      maxTargets: 5,
      power: 8,
      attackCoefficient: 0.39,
      radius: 77,
      fieldSlow: 0.185,
    },
    10: {
      chakraCost: 36,
      cooldownMs: 10_000,
      range: 210,
      maxTargets: 5,
      power: 8,
      attackCoefficient: 0.4,
      radius: 78,
      fieldSlow: 0.2,
    },
  },
  visual: {
    effectId: 37,
    castEffectId: null,
    fieldPulseEffectId: 37,
    impactEffectId: 37,
  },
};
